import AppListing from '../app-components/Listing/AppListing';

Vue.component('employee-listing', {
    mixins: [AppListing],
    data: function data() {
        return {
            /*pagination: {
                state: {
                    per_page: this.$cookie.get('per_page') || 10, // required
                    current_page: 1, // required
                    last_page: 1, // required
                    from: 1,
                    to: 10 // required
                },
                options: {
                    alwaysShowPrevNext: true
                }
            }, */
            orderBy: {
                column: 'last_name',
                direction: 'asc'
            },
            filters: {
                'position_id': 'all',
                'status': 'all',
                'contract_type_id': 'all',
            },
            search: ''
        };
    },

    created() {

    },

    props: {
        'trans': { type: Object },
    },

    methods: {
        showModal(id, existsRelatedData) {
            this.$refs.deleteEmployeeForm.open(id, null, !existsRelatedData);
        },

        gridColumnsSetting() {
            this.$modal.show('employee-grid-columns');
        },

        resetFilter() {
            this.filters.status='all';
            this.filters.position_id='all';
            this.filters.contract_type_id = 'all';
            this.search = '';
        },

        isFiltered() {
            if(this.filters.status !='all' || this.filters.position_id != 'all' || this.filters.contract_type_id != 'all' || this.search != '')
            {
                return 1;
            }else
            {
                return 0
            }
        },

        getDynamicFieldValue(item, id) {
            return item.dynamicFieldsValues[id] || '';
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/Listing.js